import { createHttpHeaderWithAuthorization } from "../../../services/http-header";
import { callWithRetry } from "../../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../../config";

export const balanceConstants = {
  GET_BALANCE_READ_START: "GET_BALANCE_READ_START",
  GET_BALANCE_READ_SUCCESS: "GET_BALANCE_READ_SUCCESS",
  GET_BALANCE_READ_ERROR: "GET_BALANCE_READ_ERROR",

  CLEAR_SEARCH_PARAMETERS: "CLEAR_SEARCH_PARAMETERS"
};

export function clearParameters() {
  return dispatch => {
    dispatch({
      type: balanceConstants.CLEAR_SEARCH_PARAMETERS
    });
  };
}

export function getBalanceRead(
  yearRef,
  fromDate,
  toDate,
  mode
) {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const modeForApi = mode ? "COMPETENCE" : "ENTRY";

    return new Promise((resolve, reject) => {
      const parameters = {
        yearRef: yearRef,
        fromDate: fromDate,
        toDate: toDate,
        model: "balance"
      };

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/ledger?managerId=${managerId}&itemId=${itemId}&fromDate=${fromDate}&toDate=${toDate}&mode=${modeForApi}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: balanceConstants.GET_BALANCE_READ_START,
        payload: { parameters: parameters }
      });

      callWithRetry(
        auth, request, dispatch, null, true, false, ["400", "401"]
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: balanceConstants.GET_BALANCE_READ_SUCCESS,
              payload: { data: result.data, parameters: parameters }
            });
            resolve(result);
          } else {
            dispatch({
              type: balanceConstants.GET_BALANCE_READ_ERROR,
              error: { error: result, parameters: parameters }
            });
            reject();
          }
        })
        .catch(err => {
          dispatch({
            type: balanceConstants.GET_BALANCE_READ_ERROR,
            error: { error: err, parameters: parameters }
          });
          reject();
        });
    });
  };
}
